export default __webpack_public_path__ + "static/media/hedgeblue_logo_light.2777cff2.png";